module.exports = __webpack_public_path__ + "static/img/birthday1.5c49d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/birthday1.png
// module id = DlsY
// module chunks = 1